import { Box } from '@mui/material';
import theme from 'theme/theme';
import { PCNode } from '../../MineModel/Nodes';
import { Model } from '../../hooks/useModelState';
import { handleNavigateToSelectedStopeScene, handleStopeSelect, SceneProps } from '../scene-utils';
import { Scene } from '../types';
import sideDrawerContentFunction from './DefaultSceneSideDrawer';
import ModelDrawerTrigger from '../../ModelDrawerTrigger';
import { IntersectionData } from '../../MineModel/intersectionTypes';

const TITLE = 'DEFAULT SCENE';

function sideDrawerSelect(model: Model, node: PCNode, props: SceneProps, stopeId?: string): void {
  handleNavigateToSelectedStopeScene(model, node, props, stopeId);
}

function sideDrawerHover(): void { }

const DefaultSceneDisplay = ({ props }: { props: SceneProps }) => (
  <>
    {!props.context.state.drawerOpen && (
      <Box
        sx={{ position: 'absolute', right: theme.spacing(2), zIndex: 20 }}
      >
        <ModelDrawerTrigger handleClick={() => props.context.actions.setDrawerOpen(true)} />
      </Box>
    )}
  </>
);

const handleNode = (model: Model, node: PCNode, props: SceneProps, stopeId?: string) => {
  if (node.isStope) {
    handleStopeSelect(model, node, props, stopeId);
  } else {
    model.setSelectedNode(node);
    props.context.actions.editNodes(true);
  }
};

const defaultScene = (props: SceneProps): Scene => {
  const display = () => <DefaultSceneDisplay props={props} />;
  const getCanvasHandlers = (model: Model) => ({
    onNodeHover: () => { },
    onNodeSelect: (node: PCNode, stopeId?: string) => {
      handleNode(model, node, props, stopeId);
    },
    onPlantIconSelect: (node: PCNode) => {
      model.setActiveBackfillPlant(node);
    },
    // Spools are edited from the Editor (BULK_EDIT) scene only.
    onSpoolSelect: () => { },
    // A click near a node lands on the node, even when it also hits a pipe.
    onIntersections: (intersections: IntersectionData[]) => {
      const nodeIntersection = intersections.find((i) => i.type === 'node' && i.node);
      if (nodeIntersection && nodeIntersection.node) {
        handleNode(model, nodeIntersection.node, props);
      }
    },
  });

  const sideDrawerContent = (model: Model) => (
    sideDrawerContentFunction(
      props,
      model,
      sideDrawerSelect,
      sideDrawerHover,
    )
  );

  return {
    key: props.key,
    display,
    getCanvasHandlers,
    sideDrawerContent,
    title: TITLE,
    actionButtons: [],
  };
};

export default defaultScene;
